import React from 'react';
import { FadeIn } from './ui/FadeIn';
export const AboutAuthor = () => {
  return <section className="py-20 md:py-24 bg-dark relative" data-id="element-11">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-neon/5 rounded-full blur-[100px] pointer-events-none" data-id="element-12" />

      <div className="container mx-auto px-4 max-w-3xl relative z-10" data-id="element-13">
        <FadeIn data-id="element-14">
          <div className="text-center mb-10" data-id="element-15">
            <span className="text-[#ADFF2F] font-bold tracking-[0.2em] uppercase text-sm mb-4 block" data-id="element-16">
              Sobre el autor
            </span>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-17">
          <div className="bg-[#111111] border border-white/10 rounded-2xl p-8 md:p-10" data-id="element-18">
            <div className="flex flex-col items-center md:flex-row md:items-start gap-6 mb-8" data-id="element-19">
              <div className="shrink-0 w-24 h-24 md:w-28 md:h-28 rounded-full overflow-hidden ring-2 ring-[#ADFF2F] ring-offset-2 ring-offset-[#111111] shadow-[0_0_20px_rgba(173,255,47,0.25)]" data-id="element-20">
                <img src="https://cdn.magicpatterns.com/uploads/vM3V2ZEXFwte6hr5hxWf1c/WhatsApp_Image_2026-05-17_at_2.19.20_PM.jpg" alt="Edisson Ricardo Ramírez" className="w-full h-full object-cover" data-id="element-21" />
              </div>
              <div className="text-center md:text-left" data-id="element-22">
                <h3 className="text-2xl md:text-3xl font-bold text-white mb-1 leading-tight" data-id="element-23">
                  Edisson Ricardo Ramírez
                </h3>
                <p className="text-[#ADFF2F] font-medium font-sans m-0" data-id="element-24">
                  Consultor en estrategias de liquidez inmediata
                </p>
              </div>
            </div>

            <div className="space-y-5" data-id="element-25">
              <p className="text-base md:text-lg text-gray-300 leading-relaxed font-sans m-0" data-id="element-26">
                Edisson Ricardo Ramírez es consultor especializado en
                estrategias de{' '}
                <span className="text-white font-semibold" data-id="element-27">
                  liquidez inmediata y micro-servicios
                </span>{' '}
                para personas en Latinoamérica y España.
              </p>
              <p className="text-base md:text-lg text-gray-300 leading-relaxed font-sans m-0" data-id="element-28">
                Esta guía nació de investigar qué servicios tienen demanda real
                hoy y cómo ejecutarlos con lo que cualquier persona ya tiene
                disponible.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};